import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock, faFolder, faNewspaper, faTruck,
} from '@fortawesome/pro-light-svg-icons'

import {
  Button, Tools,
} from '@domain-group/suit-theme'

const PublicationTools = (props) => {
  const { publicationPayload } = props

  const {
    callbacks: {
      editPublicationDeliverySettings,
      editPublicationFTPSettings,
      managePublicationDeadlines,
      managePublicationPrintSpecifications,
    },
  } = publicationPayload

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTruck} />}
        marginBottom="medium"
        onClick={() => editPublicationDeliverySettings()}
        size="medium"
      >
        Delivery Settings
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faFolder} />}
        marginBottom="medium"
        onClick={() => editPublicationFTPSettings()}
        size="medium"
      >
        File Transfer Settings
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faNewspaper} />}
        marginBottom="medium"
        onClick={() => managePublicationPrintSpecifications()}
        size="medium"
      >
        Print Specifications
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faClock} />}
        onClick={() => managePublicationDeadlines()}
        size="medium"
      >
        Edition Deadlines
      </Button>
    </Tools>
  )
}

PublicationTools.propTypes = {
  publicationPayload: PropTypes.object.isRequired,
}

export default PublicationTools
